// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2KWfu_dH6SCitWxHfArdJC {\n  margin-bottom: 10px;\n}\n\n._28yuCNSdcKjB4dxFgs5fAi {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  background: #fff;\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n}\n\n._2twl9KPDSJZF7Fo96byzLK {\n  margin-bottom: 91px;\n}\n\n._27iZ2dF_5EiJmajMTLvl8j {\n  padding-bottom: 5px;\n}\n\n._3tpxRWzY8c-espsOr7sRkz {\n  margin-right: 10px;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n}\n\n._3tpxRWzY8c-espsOr7sRkz .badge {\n  margin-left: 5px;\n}\n\n._2zQAS5sLQdmIjPXgXkesOq {\n  margin-top: 0;\n  text-align: center;\n}\n\n._2ivKu0BwBifwHgsO5FFRuS {\n  margin-bottom: 16px;\n}\n", ""]);
// Exports
exports.locals = {
	"calendarBtn": "_2KWfu_dH6SCitWxHfArdJC",
	"confirmBox": "_28yuCNSdcKjB4dxFgs5fAi",
	"timereportBox": "_2twl9KPDSJZF7Fo96byzLK",
	"timeSummaryBox": "_27iZ2dF_5EiJmajMTLvl8j",
	"timeSummary": "_3tpxRWzY8c-espsOr7sRkz",
	"header": "_2zQAS5sLQdmIjPXgXkesOq",
	"calendarBox": "_2ivKu0BwBifwHgsO5FFRuS"
};
module.exports = exports;
